import React from 'react'
import styles from "./AccountActivated.module.scss";
import Modal from '../Modal/Modal';
import { TickIcon } from '../../../../assets/icons/svgicons';
import Button from '../../Button/Button';
import { useDispatch } from 'react-redux';
import { setUserKyc } from '../../../../features/user/userSlice';

const AccountActivated = ({ show, handleClose }) => {
    const dispatch = useDispatch();
    return (
        <Modal
            show={show}
            variant="light"
            handleClose={handleClose}
            className={styles.account_activated}
        >
            <span className={styles.tick_icon}>
                <TickIcon />
            </span>
            <h3>Account Activated</h3>
            <p>Your account and digital wallet is activated. Now, You will be able to purchase tokens on the platform.</p>
            <Button
                fluid
                className={styles.continue_btn}
                onClick={() => {
                    dispatch(setUserKyc("verified"));
                    handleClose();
                }}
            >
                Continue
            </Button>
        </Modal>
    )
}

export default AccountActivated
